import { logger } from "@/lib/logger";
import type { AnalyticsAdapter, AnalyticsEvent } from "@/modules/analytics/types";

const BEACON_ID = "cf-beacon";
const BEACON_SRC = "https://static.cloudflareinsights.com/beacon.min.js";

export interface CloudflareAdapterOptions {
  token: string;
}

export function createCloudflareAdapter({
  token,
}: CloudflareAdapterOptions): AnalyticsAdapter {
  return {
    id: "cloudflare-web-analytics",
    requiresConsent: false,
    init(): void {
      if (typeof document === "undefined") return;
      if (document.getElementById(BEACON_ID)) return;
      const script = document.createElement("script");
      script.id = BEACON_ID;
      script.defer = true;
      script.src = BEACON_SRC;
      script.dataset.cfBeacon = JSON.stringify({ token });
      document.head.append(script);
      logger.info("analytics.cloudflare initialized");
    },
    page(path): void {
      logger.debug("analytics.cloudflare page", { path });
    },
    track(event: AnalyticsEvent): void {
      logger.debug("analytics.cloudflare track", { event: event.name });
    },
    shutdown(): void {
      if (typeof document === "undefined") return;
      document.getElementById(BEACON_ID)?.remove();
    },
  };
}
